// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"SiteHeader_mainNav__0clK_","logo":"SiteHeader_logo__Q1f4V","navLink":"SiteHeader_navLink__OnDvU"};